import React from 'react';
type GoldDividerProps = {
  className?: string;
};
export function GoldDivider({
  className = ''
}: GoldDividerProps) {
  return <div className={`flex w-full items-center gap-[clamp(0.75rem,0.9vw,2rem)] ${className}`} aria-hidden="true" data-id="element-7" data-mp="1dqpr83nxgtpf">
      <span className="h-px flex-1 bg-gradient-to-r from-transparent via-gold/50 to-gold/80" data-id="element-8" data-mp="ztt1y6ngjkan" />
      <span className="h-[clamp(0.5rem,0.5vw,1.1rem)] w-[clamp(0.5rem,0.5vw,1.1rem)] shrink-0 rotate-45 bg-gold-gradient" data-id="element-9" data-mp="14snsjuro2d5b" />
      <span className="h-px flex-1 bg-gradient-to-l from-transparent via-gold/50 to-gold/80" data-id="element-10" data-mp="us3qipwbp4m1" />
    </div>;
}